import { createReducer } from "@reduxjs/toolkit";
import { Project } from "../../entities/project";
import { arrayToMap } from "../../helpers";
import {
  deleteProjectSuccess,
  getProjectByIdSuccess,
  getProjectsSearchMetadataSuccess,
  getProjectsSuccess,
  setProjectFilters,
  setProjectFormOpen,
  setProjectLoading,
  setProjectSearchOpen,
  setSelectedProjectID,
  setStagedProject,
  updateStagedProject,
} from "./projectActions";
import { ProjectState } from "./projectState";

function initState(): ProjectState {
  return {
    projects: {},
    searchOpen: false,
    searchMetadata: undefined,
    loading: false,
    stagedProject: undefined,
    selectedProjectID: undefined,
    projectFormOpen: false,
  };
}

export const projectReducer = createReducer(initState(), (builder) => {
  builder.addCase(setProjectFormOpen, (state, action) => {
    state.projectFormOpen = action.payload.open;
    return state;
  });
  builder.addCase(setProjectLoading, (state, action) => {
    state.loading = action.payload.loading;
    return state;
  });
  builder.addCase(setStagedProject, (state, action) => {
    state.stagedProject = action.payload.stagedProject;
    return state;
  });
  builder.addCase(setProjectFilters, (state, action) => {
    state.filters = action.payload.filters;
    return state;
  });
  builder.addCase(setProjectSearchOpen, (state, action) => {
    state.searchOpen = action.payload.searchOpen;
    return state;
  });
  builder.addCase(updateStagedProject, (state, action) => {
    if (!state.stagedProject) return state;
    state.stagedProject = {
      ...state.stagedProject,
      ...action.payload.stagedProject,
    };
    return state;
  });
  builder.addCase(setSelectedProjectID, (state, action) => {
    state.selectedProjectID = action.payload.projectID;
    return state;
  });
  builder.addCase(getProjectsSuccess, (state, action) => {
    const projects = action.payload.projects;
    state.projects = arrayToMap<Project>(projects);
    return state;
  });
  builder.addCase(getProjectsSearchMetadataSuccess, (state, action) => {
    state.searchMetadata = action.payload.projectsSearchMetadata;
    return state;
  });
  builder.addCase(deleteProjectSuccess, (state, action) => {
    const projectID = action.payload.projectID;
    if (state.projects[projectID]) {
      delete state.projects[projectID];
    }
    return state;
  });
  builder.addCase(getProjectByIdSuccess, (state, action) => {
    const project = action.payload.project;
    if (project) {
      const projects = { ...state.projects };
      projects[project.id] = project;
      state.projects = projects;
    }
    return state;
  });
});
